import {
    trackTimesgridClickTime,
    trackTimesgridClickNext,
    trackTimesgridClickPrev,
    trackTimesgridClickMoreTimes,
    trackTimesgridClickNextAvailable,
    trackTimesgridLoaded,
} from './actions';

export const mapDispatchToProps = {
    trackTimesgridClickTime,
    trackTimesgridClickNext,
    trackTimesgridClickPrev,
    trackTimesgridClickMoreTimes,
    trackTimesgridClickNextAvailable,
    trackTimesgridLoaded,
};
